import { Injectable } from '@angular/core';


@Injectable({
    providedIn: 'root'
})
export class FormDataHelper {
    constructor() { }

    public static ToFormData(obj, form?, namespace?, type?) {
        return new FormDataHelper().ToFormData(obj, form, namespace, type);
    }

    public ToFormData(obj, form?, namespace?, type?) {
        var formData = form || new FormData();
        var formKey;

        for (var property in obj) {

            if (obj.hasOwnProperty(property)) {
                if (type == "array") {
                    formKey = namespace + '[]';
                }
                if (obj[property] instanceof File) {
                    if (namespace && property && isNaN(<any>property)) {
                        formKey = namespace + '[' + property + ']';
                    } else {
                        formKey = namespace || property;
                    }
                }
                else if (namespace) {
                    formKey = namespace + '[' + property + ']';
                } else {
                    formKey = property;
                }
                if (typeof obj[property] === 'object' && !(obj[property] instanceof Date) && !(obj[property] instanceof File) && !(obj[property] instanceof Array)) {
                    if (namespace) {
                        this.ToFormData(obj[property], formData, namespace + '[' + property + ']');
                    }
                    else {
                        this.ToFormData(obj[property], formData, property);
                    }

                } else if (obj[property] instanceof Date) {
                    formData.append(formKey, obj[property].toISOString());
                }
                else if (obj[property] instanceof Array) {
                    if (namespace) {
                        this.ToFormData(obj[property], formData, namespace + '[' + property + ']', "array");
                    }
                    else {
                        this.ToFormData(obj[property], formData, property);
                    }
                } else if (obj[property] instanceof File) {
                    formData.append(formKey, obj[property], obj[property].name);
                } else {
                    formData.append(formKey, obj[property]);
                }

            }
        }
        return formData;
    }


    public static toQueryData(obj, form?, namespace?, type?) {
        return new FormDataHelper().toQueryData(obj, form, namespace, type);
    }

    public toQueryData(obj, form?, namespace?, type?) {
        var queryData = form || {};
        var formKey;

        for (var property in obj) {

            if (obj.hasOwnProperty(property)) {
                if (type == "array") {
                    formKey = namespace + '[]';
                }
                if (namespace) {
                    formKey = namespace + '[' + property + ']';
                } else {
                    formKey = property;
                }
                if (typeof obj[property] === 'object' && !(obj[property] instanceof Date) && !(obj[property] instanceof Array)) {
                    if (namespace) {
                        this.toQueryData(obj[property], queryData, namespace + '[' + property + ']');
                    }
                    else {
                        this.toQueryData(obj[property], queryData, property);
                    }

                } else if (obj[property] instanceof Date) {
                    queryData[formKey] = obj[property].toISOString();
                }
                else if (obj[property] instanceof Array) {
                    if (namespace) {
                        this.toQueryData(obj[property], queryData, namespace + '[' + property + ']', "array");
                    }
                    else {
                        this.toQueryData(obj[property], queryData, property);
                    }
                } else {
                    queryData[formKey] = obj[property];
                }

            }
        }
        return queryData;
    }

}
